/**
 * @file api/templates.js
 * @location src/integrations/supabase/api/templates.js
 * @role 반복 업무 템플릿 CRUD RPC 래퍼.
 */
import { rowToTemplate } from '../mappers.js';
import { callRpc, callRpcId } from './_call.js';

const callTemplate = (fn, args) => callRpc(fn, args, rowToTemplate);

/** id 는 호출 측 생성(낙관적 업데이트 일치). */
export const addTemplate = (t) => callTemplate('rpc_add_template', {
  p_id: t.id, p_title: t.title, p_aees: t.aees ?? [], p_repeat: t.repeat,
});

export const editTemplate = (id, patch) => callTemplate('rpc_edit_template', {
  p_id: id, p_title: patch.title ?? null,
  p_aees: patch.aees ?? null, p_repeat: patch.repeat ?? null,
});

export const toggleTemplate = (id) => callTemplate('rpc_toggle_template', { p_id: id });
export const deleteTemplate = (id) => callRpcId('rpc_delete_template', { p_id: id }, id);
